export default __webpack_public_path__ + "static/sketch-2-00a8b9cf923e4d03d646919b0958bab0.png";